import { render, staticRenderFns } from "./WhatsAppSettingsCard.vue?vue&type=template&id=55b411d5"
import script from "./WhatsAppSettingsCard.vue?vue&type=script&lang=ts"
export * from "./WhatsAppSettingsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports